var map = {
	"./certificate_demo_course.png": "./cheops/img/certificate_demo_course.png",
	"./certificate_demo_course_yellow.png": "./cheops/img/certificate_demo_course_yellow.png",
	"./certificate_demo_quiz.png": "./cheops/img/certificate_demo_quiz.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./cheops/img sync recursive ^\\.\\/certificate_demo_.*\\.png$";